import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { BehaviorSubject } from 'rxjs';

import { FeatureEnum } from '@app/plan-manager/plan-manager.model';

import { NavigationItem } from '../navigation-components.model';
import { NavigationComponentsService } from '../navigation-components.service';

import { MenuState } from './header.model';

@Injectable({
  providedIn: 'root'
})
export class HeaderService {
  public menuState: BehaviorSubject<MenuState> = new BehaviorSubject<MenuState>(
    new MenuState()
  );

  constructor(
    private navigationComponentsService: NavigationComponentsService,
    public dialog: MatDialog
  ) {}

  get getMenuState() {
    return this.menuState.asObservable();
  }

  public toggleMenuVisibility(currentState: boolean) {
    this.menuState.next(new MenuState(!currentState, false));
  }

  public toggleProfileVisibility(currentState: boolean) {
    this.menuState.next(new MenuState(false, !currentState));
  }

  public closeMenus(): void {
    this.menuState.next(new MenuState());
  }

  public closeSubmenus(menuState: MenuState): void {
    this.menuState.next(new MenuState(menuState.isMenuOpen, false, false));
  }

  public setSubmenuAsOpened(menuState: MenuState): void {
    this.menuState.next(new MenuState(menuState.isMenuOpen, false, true));
  }

  public featAction(feature: FeatureEnum, registration: string) {
    this.navigationComponentsService.featAction(feature, registration);
    this.closeMenus();
  }

  public handleProfileNavigationItemAction(item: NavigationItem): void {
    this.navigationComponentsService.handleProfileNavigationItemAction(item);
    this.closeMenus();
  }

  public navigateTo(url: string): void {
    this.navigationComponentsService.navigateTo(url);
    this.closeMenus();
  }
}
